<template>
    <component :is="tag">
        <slot
            :brief="brief"
            :is-loading="isLoading"
            :errors="errors"
            :error-message="errorMessage"
            :on-page-close="onPageClose"
            :deliverable="contentApprovalDeliverable"
            :task="task"
            :upload-content-url="uploadContentUrl"
            :requires-caption-approval="requiresCaptionApproval"
            :handle-file-change="handleFileChange"
            :handle-reset-uploads="handleResetUploads"
            :upload-headers="uploadHeaders"
            :uploaded-files="uploadedFiles"
            :has-uploaded-files="hasUploadedFiles"
            :is-file-uploading="isFileUploading"
            :handle-refresh-deliverable="handleRefreshDeliverable"
            :go-back="onBack"
        />
    </component>
</template>

<script>
    import useDeliverables from '../../../../src/composables/use-deliverables';
    import ActivationBriefTasksMixin from '../mixins/ActivationBriefTasksMixin';
    import BaseActivationBriefStepMixin from '../mixins/BaseActivationBriefStepMixin';
    import ContactsMixin from '../mixins/ContactsMixin';
    import UploadMixin from '../mixins/UploadMixin';

    export default {
        name: 'ActivationDeliverableContentApprovalProvider',
        mixins: [ContactsMixin, BaseActivationBriefStepMixin, ActivationBriefTasksMixin, UploadMixin],
        data() {
            const exitRoute =
                this.$route.params.context === 'summary' ? 'v2.activation.tasks.summary' : 'v2.activation.brief.tasks';
            const backRoute = this.$route.params.back_route;
            const context = this.$route.params.context;
            return {
                isLoading: false,
                isFileUploading: false,
                contentApprovalDeliverable: null,
                exitRoute,
                context,
                backRoute
            };
        },

        async created() {
            this.isLoading = true;

            try {
                await this.loadContact(true);
                await this.loadActivationBrief(true);
                await this.loadContentApproval();
            } catch (error) {
                this.handleHttpError(error);
            }

            this.isLoading = false;
        },

        methods: {
            onPageClose() {
                this.$router.push({
                    name: this.exitRoute,
                    params: { context: this.context }
                });
            },
            onBack() {
                if (this.task.quantity > 1) {
                    this.$router.push({
                        name: 'v2.activation.brief.task.deliverables',
                        params: {
                            task_id: this.task.id,
                            context: this.context,
                            back_route: this.backRoute
                        }
                    });
                } else {
                    this.$router.push({
                        name: 'v2.activation.brief.tasks',
                        params: { context: this.context }
                    });
                }
            },
            async loadContentApproval() {
                const response = await useDeliverables().getDeliverable(
                    this.briefParamId,
                    this.$route?.params?.deliverable_id
                );
                this.contentApprovalDeliverable = response.data;
            },
            async handleRefreshDeliverable() {
                this.isLoading = true;
                await this.loadContentApproval();
                this.isLoading = false;
            },
            handleFileChange(info) {
                this.isFileUploading = true;
                this.handleUploadChange(
                    info,
                    () => (this.isFileUploading = false),
                    () => {
                        this.handleUploadError(info);
                        this.isFileUploading = false;
                    },
                    true
                );
            },
            handleResetUploads() {
                this.handleResetUploadedFiles();
            }
        },
        computed: {
            uploadContentUrl() {
                return `/activation-briefs/${this.briefParamId}/tasks/${this.taskParamId}/content-approval/upload`;
            },
            requiresCaptionApproval() {
                return !!this.task?.requires_caption_approval;
            }
        }
    };
</script>
